import { Component, Input, input, OnInit } from '@angular/core';
import { Tipologia } from '../../models/tipologias.model';

@Component({
    selector: 'form-type-widget',
    template: `
    
    <div class="text-sm  bg-amber-300 rounded-full w-8 h-8 flex items-center justify-center font-bold">
        {{clasificacion.valor2}}
    </div>`
})

export class FormTypeWidgetComponent implements OnInit {

    @Input() clasificacion: Tipologia
    constructor() { }

    ngOnInit() { }
}